// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SimplePaperPodcast-cls1___7ac9d0ebac6e6a906db{/*!*/}.SimplePaperPodcast-cls2___ea44d97375af1074cba{flex:1 1;min-width:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SimplePaperPodcast-cls1___7ac9d0ebac6e6a906db",
	"cls2": "SimplePaperPodcast-cls2___ea44d97375af1074cba SimplePaperPodcast-cls1___7ac9d0ebac6e6a906db"
};
export default ___CSS_LOADER_EXPORT___;
